<template>
  <section class="container">
    <div v-if="showIntro">
      <div id="intro" class="card fixed fixed--center rounded-borders" @click="nextIntroDot()">
        <transition-group name="list" tag="p">
          <div key="1" class="intro-item" v-show="currentDot === 1">
            <div class="introImage">
              <img height="80px" src="../assets/svg/checkmark_icon.svg"/>
            </div>
            <div class="introText">Welcome to the Mobility Solution Match.</div>
          </div>
          <div key="2" class="intro-item" v-show="currentDot === 2">
            <div class="introImage">
              <img height="80px" src="../assets/svg/web_icon.svg"/>
            </div>
            <div class="introText">
              Before you get started, review this website to learn about the
              availability of charging stations across the USA.
            </div>
            <div class="continueButton" @click="visitWebsite()">
              Visit Website
            </div>
          </div>
          <div key="3" class="intro-item" v-show="currentDot === 3">
            <div class="introImage">
              <img height="80px" src="../assets/svg/ev_icon.svg"/>
            </div>
            <div class="introText">
              Swipe right to match your customer <br> with an electric vehicle.
            </div>
          </div>
          <div key="4" class="intro-item" v-show="currentDot === 4">
            <div class="introImage">
              <img height="80px" src="../assets/svg/traditional_icon.svg"/>
            </div>
            <div class="introText">
              Swipe left to match your customer <br> with a traditional vehicle.
            </div>
          </div>
        </transition-group>
        <div id="introDots" style="text-align:center">
          <span id="dot1" class="dot dot--active"></span>
          <span id="dot2" class="dot"></span>
          <span id="dot3" class="dot"></span>
          <span id="dot4" class="dot"></span>
        </div>
        <div v-show="currentDot === 4" class="continueButton" @click="showIntro = false">
              Get Started
        </div>
      </div>
    </div>
    <div id="currentCard" class="fixed fixed--profile"
    v-if="!showExplanation && !showIntro && !showFinalScore">
      <Vue2InteractDraggable
        v-if="cardVisible"
        :interact-out-of-sight-x-coordinate="500"
        :interact-max-rotation="15"
        :interact-x-threshold="190"
        :interact-y-threshold="9999"
        :interact-event-bus-events="interactEventBusEvents"
        @draggedRight="right()"
        @draggedLeft="left()"
        options="disabled: true">
        <div class="flex flex--center" @mousedown="collapseDet()" @touchstart="collapseDet()">
          <img class="profilePicture" :src="getImageSrc(current.image)"/>
        </div>
        <div class="rounded-borders card card--one">
          <div class="characterName">{{ Object.keys(this.characters)[this.index] }}</div>
          <div class="characterAge">Age: {{current.age}}</div>
          <div class="customerDetailExpand">
            <span>Customer Details</span>
            <img class="carrot" src="../assets/svg/carrot_expand.svg"/>
          </div>
        </div>
      </Vue2InteractDraggable>
      <div class="bio rounded-borders" style="z-index: 6">
          <div class="characterNameBio">{{ Object.keys(this.characters)[this.index] }}</div>
          <div class="characterAgeBio">Age: {{current.age}}</div>
          <div class="customerDetailCollapse" @click="collapseDetailsManual()">
            <span>Customer Details</span>
            <img class="carrot" src="../assets/svg/carrot_collapse.svg"/>
          </div>
          <div class="openBioText" v-html="current.bio">
          </div>
      </div>
      <div class="buttonControls fixed fixed--buttons" v-if="!showExplanation">
        <span> <img @click="selectTraditional()" src="../assets/svg/traditional_icon.svg"/> </span>
        <span> <img @click="selectEv()" src="../assets/svg/ev_icon.svg"/> </span>
      </div>
    </div>
    <span id="expandDetailPanel" v-if="!showIntro && !showExplanation" @click="expandDetails()">
    </span>
    <div
      v-if="next && displayBackground && !showExplanation  && !showIntro"
      class="fixed fixed--center" id="background-card"
      style="z-index: 2">
      <div class="flex flex--center" >
          <img class="profilePicture" :src="getImageSrc(next.image)"/>
        </div>
        <div class="rounded-borders card card--one">
          <div class="characterName">{{ Object.keys(this.characters)[this.index + 1] }}</div>
          <div class="characterAge">Age: {{next.age}}</div>
          <div class="customerDetailExpand">
            <span>Customer Details</span>
            <img class="carrot" src="../assets/svg/carrot_expand.svg"/>
          </div>
        </div>
    </div>
    <div v-if="showExplanation && !showIntro" id="remediation">
      <div class="card fixed fixed--explanation rounded-borders" style="z-index: 15">
        <div>
          <img class="responseImage" :src="getAnswerImageSrc()"/>
          <div class="isCorrectLabel"> {{isCorrect ? "Correct" : "Incorrect"}} </div>
          <div class="explanation" v-html="previous.explanation"> </div>
          <div class="continueButton" @click="continueMatching()"> Continue </div>
        </div>
      </div>
    </div>
    <div v-if="showFinalScore">
      <div class="card rounded-borders fixed fixed--center" id="finalScoreCard">
          <div class="introImage">
            <img height="100px" src="../assets/svg/checkmark_icon.svg"/>
          </div>
          <div id="yourResultsLabel">Your Results</div>
          <div id="finalScore">{{score}}/10</div>
          <div class="continueButton" @click="completeActivity()"> Complete Activity </div>
          <div id="playAgainButton" @click="resetGame()">Play Again</div>
      </div>
    </div>
  </section>
</template>
<script>
import { Vue2InteractDraggable, InteractEventBus } from 'vue2-interact';
import charactersJson from '../data/characters.json';

const INTERACT_DRAGGED_LEFT = 'INTERACT_DRAGGED_LEFT';
const INTERACT_DRAGGED_RIGHT = 'INTERACT_DRAGGED_RIGHT';

export default {
  name: 'MobilityMatcher',
  components: {
    Vue2InteractDraggable,
  },
  data() {
    return {
      score: 0,
      showIntro: true,
      currentDot: 1,
      transitioningDot: false,
      showFinalScore: false,
      cardVisible: true,
      displayBackground: true,
      characters: charactersJson,
      showExplanation: false,
      isCorrect: true,
      index: 0,
      interactEventBusEvents: {
        draggedLeft: INTERACT_DRAGGED_LEFT,
        draggedRight: INTERACT_DRAGGED_RIGHT,
      },
    };
  },
  computed: {
    current() {
      return this.characters[Object.keys(this.characters)[this.index]];
    },
    next() {
      return this.characters[Object.keys(this.characters)[this.index + 1]];
    },
    previous() {
      return this.characters[Object.keys(this.characters)[this.index - 1]];
    },
  },
  methods: {
    selectTraditional() {
      this.collapseDetailsManual();
      InteractEventBus.$emit(INTERACT_DRAGGED_LEFT);
    },
    selectEv() {
      this.collapseDetailsManual();
      InteractEventBus.$emit(INTERACT_DRAGGED_RIGHT);
    },
    right() {
      if (this.getCorrectAnswer() === 'EV' || this.getCorrectAnswer() === 'either') {
        this.score += 1;
        this.isCorrect = true;
      } else {
        this.isCorrect = false;
      }
      this.getNextCharacter();
      setTimeout(() => this.showRemediation(), 200);
    },
    left() {
      if (this.getCorrectAnswer() === 'T' || this.getCorrectAnswer() === 'either') {
        this.score += 1;
        this.isCorrect = true;
      } else {
        this.isCorrect = false;
      }
      this.getNextCharacter();
      setTimeout(() => this.showRemediation(), 200);
    },
    continueMatching() {
      if (this.index === 10) {
        this.showFinalScore = true;
      }
      this.showExplanation = false;
    },
    expandDetails() {
      const details = document.querySelector('.bio');
      details.classList.add('openBio');
      const profilePicture = document.querySelector('.profilePicture');
      profilePicture.classList.add('openBioProfilePicture');
      this.toggleBackground();
    },
    collapseDetailsManual() {
      const details = document.querySelector('.bio');
      details.classList.remove('openBio');
      const profilePicture = document.querySelector('.profilePicture');
      profilePicture.classList.remove('openBioProfilePicture');
      setTimeout(() => this.toggleBackground(), 300);
    },
    showRemediation() {
      this.showExplanation = true;
    },
    toggleBackground() {
      const details = document.querySelector('.bio');
      if (details && details.classList.contains('openBio')) {
        this.displayBackground = false;
      } else {
        this.displayBackground = true;
      }
    },
    collapseDet() {
      const details = document.querySelector('.bio');
      if (details.classList.contains('openBio')) {
        this.collapseDetailsManual();
      }
    },
    getCharacterName() {
      return Object.keys(this.characters)[this.index];
    },
    getCharacterAge() {
      return this.characters[Object.keys(this.characters)[this.index]].age;
    },
    getCorrectAnswer() {
      return this.characters[Object.keys(this.characters)[this.index]].answer;
    },
    getNextCharacter() {
      setTimeout(() => this.setInvisible(), 200);
      setTimeout(() => this.setVisible(), 200);
    },
    setInvisible() {
      this.cardVisible = false;
      this.index += 1;
    },
    setVisible() {
      if (this.index === 10) {
        return;
      }
      this.cardVisible = true;
    },
    getImageSrc(name) {
      const images = require.context('../assets/svg/characters', false, /\.svg$/);
      return images(`./${name}`);
    },
    getAnswerImageSrc() {
      const images = require.context('../assets/svg', false, /\.svg$/);
      const filename = this.isCorrect ? 'checkmark_icon.svg' : 'incorrect_icon.svg';
      return images(`./${filename}`);
    },
    nextIntroDot() {
      if (this.currentDot === 4 || this.transitioningDot === true) {
        return;
      }
      this.transitioningDot = true;
      const previousDot = this.currentDot;
      this.currentDot = 'transitioning';
      setTimeout(() => this.transitionDot(previousDot), 300);
      const unselectDot = document.querySelector(`#dot${previousDot}`);
      if (unselectDot.classList.contains('dot--active')) {
        unselectDot.classList.remove('dot--active');
      }
    },
    transitionDot(previousDot) {
      this.currentDot = previousDot + 1;
      const selectedDot = document.querySelector(`#dot${this.currentDot}`);
      selectedDot.classList.add('dot--active');
      const introDiv = document.querySelector('#intro');
      if (introDiv.classList.contains('largeIntro')) {
        introDiv.classList.remove('largeIntro');
      } else {
        introDiv.classList.add('largeIntro');
      }
      this.transitioningDot = false;
    },
    visitWebsite() {
      window.open('https://afdc.energy.gov/data/10366', '_blank');
    },
    resetGame() {
      this.index = -1;
      this.score = 0;
      this.showFinalScore = false;
      this.getNextCharacter();
    },
    completeActivity() {
      window.close();
    },
  },
  mounted() {
  },
};
</script>
<style lang="scss" scoped>
#expandDetailPanel {
  width: 300px;
  height: 50px;
  z-index: 4;
  position: fixed;
  left: 50%;
  top: 68%;
  transform: translate(-50%, -50%);
}
#currentCard {
  z-index: 3;
}
.bio {
  max-height: 0px;
  text-align: left;
  width: 275px;
  overflow: hidden;
  position: fixed;
  background-color: #FFFFFF;
  left: 50%;
  top: 60%;
  transform: translate(-50%, -50%);
  transition: 0.3s ease max-height;
  transition: 0.7s ease opacity;
  box-shadow: 0 2px 6px rgba(0,0,0,.1);
  opacity: 0%;
}
.openBio {
  padding: 12.5px;
  padding-top: 70px;
  opacity: 1 !important;
  transition: 0.3s ease max-height;
  transition: 0.7s ease opacity;
  max-height: 68%;
  z-index: 8;
}
.openBioText {
  text-align: left;
  max-height: 12em;
  padding-bottom: 0;
  overflow: scroll;
}
.profilePicture {
  height: 100%;
  z-index: 10;
  max-height: 100%;
  transition: 0.3s ease max-height;
}
.openBioProfilePicture {
  max-height: 50%;
  position: relative;
  top: -23px;
}
.container {
  overflow: hidden;
  width: 100%;
  height: 100%;
}
.flex {
  height:300px;
  padding-bottom: 3%;
  display: flex;
  &--center {
    justify-items: center;
    justify-content: center;
  }
}
.fixed {
  position: fixed;
  &--profile {
    left: 50%;
    top: 42%;
    transform: translate(-50%, -50%);
  }
  &--center {
    left: 50%;
    top: 42%;
    transform: translate(-50%, -50%);
  }
  &--buttons {
    left: 50%;
    top: 82%;
    transform: translate(-50%, -50%);
  }
  &--explanation {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
.rounded-borders {
  border-radius: 12px;
}
.characterName {
  font-family: 'VWHead-Bold', sans-serif;
  padding-left: 12.5px;
  font-size: 22px;
  text-align: left;
  padding-bottom: 1%;
}
.characterAge {
  padding-left: 12.5px;
  font-family: 'VWHead-Light', sans-serif;
  text-align: left;
  font-size: 17px;
  padding-bottom: 4%;
}
.characterNameBio {
  font-family: 'VWHead-Bold', sans-serif;
  font-size: 22px;
  text-align: left;
  padding-bottom: 1%;
}
.characterAgeBio {
  font-family: 'VWHead-Light', sans-serif;
  text-align: left;
  font-size: 17px;
  padding-bottom: 4%;
}
.customerDetailExpand {
  font-family: 'VWHead-Bold', sans-serif;
  font-size: 18px;
  text-align: left;
  padding-top: 10px;
  border-top: 2px solid #F3F4F6;
  padding-left: 12.5px;
}
.customerDetailCollapse {
  font-family: 'VWHead-Bold', sans-serif;
  font-size: 18px;
  text-align: left;
  padding-top: 10px;
  padding-bottom: 12px;
  border-top: 2px solid #F3F4F6;
}
.carrot {
  float: right;
  position: relative;
  top: 3px;
  padding-right: 12.5px;
  height: 20px;
  width: 20px;
}
.buttonControls {
  padding-top: 320px;
  width: 200px;
  display: flex;
  justify-content: space-between;
}
.card {
  padding-top: 5%;
  padding-bottom: 5%;
  background-color: #FFFFFF;
  box-shadow: 0 2px 6px rgba(0,0,0,.1);
  width: 300px;
}
#remediation {
  max-height: 95vh;
  width: 94vw;
}
.isCorrectLabel {
  display: block;
  padding-bottom: 15px;
  padding-top: 10px;
  font-size: 20px;
  font-family: 'VWHead-Bold', sans-serif;
}
.explanation {
  display: block;
  overflow: scroll;
  padding-bottom: 20px;
  padding-left: 15px;
  padding-right: 15px;
  text-align: left;
  max-height: 45vh;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.explanation::-webkit-scrollbar {
  display: none;
}
.continueButton {
  font-family: 'VWText-Regular';
  display: block;
  background-color: #01B0F0;
  padding-left: 5px;
  padding-right: 5px;
  width: 170px;
  margin: auto;
  margin-top: 15px;
  padding-top: 10px;
  padding-bottom: 10px;
  color: #001E50;
  border-radius: 24px;
  font-size: 16px;
}
.responseImage {
  height: 80px;
}
.dot {
  width: 15px;
  height: 15px;
  background-color: rgba(0, 176, 240, 0.5);
  border-radius: 50%;
  display: inline-block;
  margin: 5px;
  &--active {
    background-color: rgba(0, 176, 240, 1);
  }
}
.introImage {
}
.introText {
  padding-top: 10px;
  padding-left: 35px;
  padding-right: 35px;
}
#introDots {
  padding-top: 10px;
}
#intro {
  z-index: 12;
  max-height: 275px;
  transition: max-height 0.6s ease-in-out, height 0.6s ease-in-out;
  width: 300px;
  font-family: 'VWHead-Light', sans-serif;
  font-size: 20px;
  padding-top: 0;
  padding-bottom: 15px;
  overflow: hidden;
}
.largeIntro {
  max-height: 400px !important;
  // transition: max-height 0.6s ease-in-out, box-shadow 0.6s linear;
}
.continueButton {
  cursor: pointer;
}
#yourResultsLabel {
  font-family: 'VWHead-Bold';
  font-size: 20px;
  font-weight: bold;
  margin-top: 10px;
}
#finalScore {
  font-size: 19px;
  margin-top: 12px;
}
#playAgainButton {
  font-family: 'VWText-Bold';
  margin-top: 18px;
  color: #01B0F0;
  font-weight: bold;
  cursor: pointer;
}
.intro-item {
  display: inline-block;
  position: static;
}
.list-enter-active {
  transition: all .3s;
  transition-delay: 300ms;
}
.list-leave-active {
  transition: all .3s;
}
.list-enter {
  opacity: 0;
  transform: translateX(70px);
  transition-delay: 800ms;
}
.list-leave-to {
  opacity: 0;
  transform: translateX(-70px);
}
.openBioText::-webkit-scrollbar {
    display: none;
}
@media (min-width: 1181px) {
  .fixed {
  position: fixed;
    &--profile {
      left: 42%;
      top: 42%;
      transform: translate(-50%, -50%);
    }
  }
  #expandDetailPanel {
    display: none;
  }
  .card--one {
    display: none;
  }
  .carrot {
    display: none;
  }
  .bio {
    position: relative;
    left: 120%;
    max-height: 68%;
    padding: 30px;
    width: 375px;
    opacity: 1 !important;
    box-shadow: 0 2px 6px rgba(0,0,0,.1);
    z-index: 11 !important;
  }
  #intro {
    z-index: 12;
    max-height: 225px;
    transition: max-height 0.6s ease-in-out, height 0.6s ease-in-out;
    width: 450px;
    font-family: 'VWHead-Light', sans-serif;
    font-size: 20px;
    padding-top: 0;
    padding-bottom: 15px;
    overflow: hidden;
  }
  #background-card {
    display: none;
  }
  .profilePicture {
    position: relative;
    right: 40%;
    top: 35%;
  }
  .buttonControls {
    position: fixed;
    top: 55%;
    padding-right: 83%;
    z-index: 8;
  }
  .customerDetailExpand {
    display: none;
  }
  .customerDetailCollapse {
    display: none;
  }
  .openBioText {
    max-height: 13em;
    overflow: scroll;
    scrollbar-width: none;
  }
  .openBioText::-webkit-scrollbar {
    display: none;
  }
  .openBioText {
    -ms-overflow-style: none;
  }
  .continueButton {
    margin-bottom: 5px;
    margin-top: 15px;
  }
  .explanation {
    padding-bottom: 15px;
    padding-top: 5px;
  }
  #remediation {
    max-height: 400px;
  }
  .fixed--explanation {
    padding: 30px;
    top: 45%;
    width: 500px;
  }
  #currentCard {
    min-height: 65%;
  }
  #finalScoreCard {
    width: 450px;
    padding-top: 45px;
    padding-bottom: 45px;
  }
}
@media (min-width: 1481px) {
.fixed {
  position: fixed;
    &--profile {
      left: 45%;
      top: 42%;
      transform: translate(-50%, -50%);
    }
  }
}
@media (max-width: 1181px) and (min-height: 795px) {
  #expandDetailPanel {
    top: 66%;
  }
}
@media (max-width: 1181px) and (max-height: 665px) {
  #expandDetailPanel {
    top: 71%;
  }
}
@media (-ms-high-contrast: none), (-ms-high-contrast: active) {
  @media (min-width: 1181px) {
    .buttonControls {
      padding-right: 0px;
      position: fixed;
      left: 29%;
      top: 42%;
    }
  }
  @media (min-width: 1480px) {
    .buttonControls {
      padding-right: 0px;
      position: fixed;
      left: 34%;
      top: 42%;
      transform: translate(-50%, -50%);
    }
  }
  @media (min-width: 1800px) {
    .buttonControls {
      padding-right: 0px;
      position: fixed;
      left: 36%;
      top: 42%;
      transform: translate(-50%, -50%);
    }
  }
}
</style>
